import { Link } from 'react-router-dom';
import { webtoonCategories, siteInfo } from '@/mocks/webtoons';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-xl text-background-50 mb-4">
              <Link to="/" className="hover:text-primary-300 transition-colors">韩漫网</Link>
            </h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">
              漫画分类
            </h4>
            <div className="flex flex-col gap-2">
              {webtoonCategories.filter(c => c.slug !== 'all').slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors whitespace-nowrap">恋爱漫画</Link>
              <Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors whitespace-nowrap">动作漫画</Link>
              <Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors whitespace-nowrap">奇幻漫画</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-400">
              <p>邮箱：contact@hanmanwang.com</p>
              <p>微信：hanmanwang2020</p>
              <p>微博：@韩漫网官方</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫网 HanManWang. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-300 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-300 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-300 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}